import { styled } from "styled-components";

import { styleHeadingM } from "style/components/Typography";

export const Container = styled.div`
    margin: 1.3125rem 0;
    width: 100%;
`;

export const Heading = styled.h2`
    ${styleHeadingM};
    margin-bottom: 2.625rem;
    margin-top: 0;
`;

export const Profiles = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2.625rem;
`;
